export const TourStepId = {
  Welcome: 'tour-welcome',
  NotificationsBell: 'tour-notifications-bell',
  UserProfile: 'tour-user-profile',
  Sidebar: 'tour-sidebar',
  UpcomingWorkshops: 'tour-upcoming-workshops',
  MonthSwitch: 'tour-month-switch',
  VideoWorkshops: 'tour-video-workshops',
  Magazine: 'tour-magazine',
  PortalGuide: 'tour-portal-guide',
  SupportLogout: 'tour-support-logout',
} as const;

export type TourStepId = (typeof TourStepId)[keyof typeof TourStepId];
